export enum JobsViewerModeEnum {
  DAY = "Day",
  WEEK = "Week",
  MONTH = "Month"
}